<ul class="nav nav-tabs" role="tablist">
  <ng-content></ng-content>
</ul>